import React from 'react';
import Typography from '@material-ui/core/Typography';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import { Link, withRouter } from 'react-router-dom';

function BreadCrumbs(props) {

  const { isCounty, isRegion, isCommodity, countyName, regionName, commodityName, regionUrlKey } = props

  if (isCounty) {
    return (
      <>
        <Breadcrumbs separator="›" aria-label="breadcrumb">
          <Link to={{
            pathname: '/overview',
            indexProps: {
              index: 0
            }
          }}>
            State of Georgia
            </Link>
          <Link to={{
            pathname: '/overview/region',
            state: { urlKey: regionUrlKey, regionName: regionName }
          }}>
            {regionName}
          </Link>
          <Typography color="textPrimary">{countyName}</Typography>
        </Breadcrumbs>
      </>
    )
  }

  if (isCommodity) {
    return (
      <>
        <Breadcrumbs separator="›" aria-label="breadcrumb">
          <Link to={{
            pathname: '/overview',
            indexProps: {
              index: 0
            }
          }}>
            State of Georgia
            </Link>
          <Link to={{
            pathname: '/overview',
            indexProps: {
              index: 2
            }
          }}>
            Commodities
            </Link>
          <Typography color="textPrimary">{commodityName}</Typography>
        </Breadcrumbs>
      </>
    )
  }

  if (isRegion) {
    return (
      <>
        <Breadcrumbs separator="›" aria-label="breadcrumb">
          <Link to={{
            pathname: '/overview',
            indexProps: {
              index: 0
            }
          }}>
            State of Georgia
            </Link>
          <Typography color="textPrimary">{regionName}</Typography>
        </Breadcrumbs>
      </>)
  }
}

export default withRouter(BreadCrumbs);